import React from "react";
const year = new Date().getFullYear();
export const Footer = () => {
  return (
    <>
      <div
        className="container-fluid app-bg-dark"
        style={{ paddingTop: "12px", paddingBottom: "14px" }}
      >
        <div className="row align-items-center justify-content-md-start justify-content-center row-gap-3">
          <div
            className="col-md-4 footer-logo-container"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
              style={{ height: "20px", width: "120px" }}
              alt=""
            />
            <div className="footer-text-container">
              <span
                style={{
                  color: "#A2A2A6",
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                }}
              >
                © {year}. JabChaho Laundry Services.{" "}
                <span className="d-block d-md-inline">
                  All Rights Reserved.
                </span>
              </span>
            </div>
          </div>
          <div className="col-md-4 text-center py-2 py-md-0">
            <div className="site-footer__social">
              <a
                href="http://www.youtube.com/@jabchahoofficial"
                target="_blank"
              >
                <i className="fa-brands fa-youtube"></i>
              </a>
              <a
                href="https://www.facebook.com/jabchahoofficial"
                target="_blank"
              >
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a
                href="https://www.instagram.com/jabchahoofficial/"
                target="_blank"
              >
                <i className="fa-brands fa-instagram"></i>
              </a>
            </div>
          </div>
          <div className="col-md-4 text-center text-md-end text-white">
            <span style={{ fontSize: "15px" }} className="text-center">
              <a
                href="mailto:support@jabchaho.com"
                style={{ color: "inherit", textDecoration: "inherit" }}
              >
                support@jabchaho.com
              </a>{" "}
              |{" "}
              <a
                href="tel:+9221111524246"
                style={{ color: "inherit", textDecoration: "inherit" }}
              >
                +9221-111-524-246
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
